import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var LoadingIndicator = function LoadingIndicator(props) {
  var parentClasses = classNames('LoadingIndicator', {
    'LoadingIndicator-fullscreen': props.fullscreen
  });
  var dotsClasses = classNames('LoadingIndicator-dots', {
    'LoadingIndicator-dots-small': props.small
  });
  var dotClasses = classNames('LoadingIndicator-loader-dot', {
    'LoadingIndicator-loader-dot-small': props.small
  });
  var top = props.top || 0;
  return React.createElement("div", {
    className: parentClasses
  }, React.createElement("div", {
    className: "LoadingIndicator-outer",
    style: {
      top: top
    }
  }, React.createElement("div", {
    className: dotsClasses
  }, React.createElement("div", {
    className: dotClasses
  }), React.createElement("div", {
    className: dotClasses
  }), React.createElement("div", {
    className: dotClasses
  }), React.createElement("div", {
    className: dotClasses
  }), React.createElement("div", {
    className: dotClasses
  }))));
};

LoadingIndicator.displayName = 'LoadingIndicator';
LoadingIndicator.propTypes = {
  small: PropTypes.bool,
  top: PropTypes.number,
  fullscreen: PropTypes.bool
};
export default LoadingIndicator;